var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  strokeWidth: "1pt"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#00319c",
  d: "M0 0h213.3v480H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffde00",
  d: "M213.3 0h213.4v480H213.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#de2110",
  d: "M426.7 0H640v480H426.7z"
}))));
export { SvgRo as ReactComponent };
export default __webpack_public_path__ + "assets/images/ro.33482fcd4344b097d6d7108dc38ed79f.svg";